<div class="ui-small-card-content"><ng-content /></div>
<mark class="ui-card-highlight"> </mark>
